import { render, staticRenderFns } from "./VueSelectPaginated.vue?vue&type=template&id=10652f5a&"
import script from "./VueSelectPaginated.vue?vue&type=script&lang=js&"
export * from "./VueSelectPaginated.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectPaginated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports